export default "__VITE_ASSET__DNaWuNqa__"